import { ENUM_DEVICE_WAY } from '@/common/enum/forward/device'
import { ENUM_ROLE_TYPE } from '@/common/enum/forward/account'
import { sensorType, sensorTypeConvert } from '@/utils/dict/sensor'

/**
 * 设备图标转换模块
 */
const t = vm.$t.bind(vm)
const unknown = {
  title: 'integration.unknown',
  icon: 'el-icon-question'
}

// 监测点类型转换
export const carrierType = {
  1: {
    title: 'carrierType.incubator',
    icon: 'iconfont icon-weibolu-xian icon',
    en_title: 'incubator'
  },
  2: {
    title: 'carrierType.refrigerator',
    icon: 'iconfont icon-bingxiang icon',
    en_title: 'fridge'
  },
  3: {
    title: 'route.car',
    icon: 'iconfont icon-qiche icon',
    en_title: 'car'
  },
  4: {
    title: 'route.refrigeratory',
    icon: 'iconfont icon-9lengku icon',
    en_title: 'refrigeratory'
  },
  5: {
    title: 'route.warehouse',
    icon: 'iconfont icon-cangkukucun icon',
    en_title: 'warehouse'
  },
  6: {
    title: 'route.store',
    icon: 'iconfont icon-dianpu icon',
    en_title: 'store'
  },
  7: {
    title: 'route.other',
    icon: 'iconfont  icon icon-qita',
    en_title: 'other'
  }
}

// 异常类型转换
const abnormal = {
  1: {
    title: 'abnormal.sensorConnect',
    icon: 'el-icon-warning icon'
  },
  2: {
    title: 'abnormal.sensorTemp',
    icon: 'el-icon-error icon'
  },
  3: {
    title: 'abnormal.sensorHum',
    icon: 'el-icon-warning-outline icon'
  },
  4: {
    title: 'abnormal.gatewayConnect',
    icon: 'el-icon-circle-close icon'
  },
  5: {
    title: 'abnormal.gatewayBlackout',
    icon: 'el-icon-close icon'
  },
  6: {
    title: 'abnormal.displayConnect',
    icon: 'el-icon-no-smoking icon'
  },
  7: {
    title: 'abnormal.relayConnect',
    icon: 'el-icon-s-operation icon'
  },
  8: {
    title: 'abnormal.relayRetain',
    icon: 'el-icon-message-solid icon'
  }
}

// 监测点状态
const carrierStatus = {
  0: {
    title: 'carrierStatus.running',
    icon: 'iconfont icon-yunhang icon'
  },
  1: {
    title: 'carrierStatus.obsolete',
    icon: 'el-icon-folder-delete icon'
  },
  2: {
    title: 'carrierStatus.spare',
    icon: 'el-icon-suitcase icon'
  },
  3: {
    title: 'carrierStatus.require',
    icon: 'el-icon-first-aid-kit icon'
  },
  4: {
    title: 'carrierStatus.defrost',
    icon: 'el-icon-brush icon'
  }
}

// 设备状态
export const equiStatus = {
  0: {
    title: 'equiStatus.offline',
    icon: 'iconfont icon-wu-WiFi  color-red'
  },
  1: {
    title: 'equiStatus.running',
    icon: 'iconfont icon-wifi icon'
  },
  2: {
    title: 'equiStatus.stop',
    icon: 'el-icon-video-play icon color-red'
  }
}

// 传感器状态 (仅用于图标i按时)
export const sensorStatus = {
  0: {
    title: 'public.online',
    icon: 'block-red'
  },
  1: {
    title: 'public.offline',
    icon: 'block-theme'
  }
}

// 设备是否异常
const isAbnormal = {
  0: {
    title: 'isAbnormal.normal',
    icon: 'el-icon-circle-check'
  },
  1: {
    title: 'isCarrierAbnormal.abnormal',
    icon: 'iconfont icon-xianshi_jinggao color-red'
  }
}
const isMapAbnormal = {
  0: {
    title: 'isCarrierAbnormal.normal',
    icon: ' el-icon-circle-check'
  },
  1: {
    title: 'isCarrierAbnormal.abnormal',
    icon: 'iconfont icon-xianshi_jinggao  color-red'
  }
}
// 监测点是否异常 --brian 添加
const isCarrierAbnormal = {
  0: {
    title: 'isCarrierAbnormal.normal',
    icon: 'el-icon-circle-check'
  },
  1: {
    title: 'isCarrierAbnormal.abnormal',
    icon: 'iconfont icon-xianshi_jinggao color-red'
  }
}
// 是否报警 --brian 添加
const isAlarm = {
  0: {
    title: 'integration.turn_off_alarm',
    icon: 'iconfont icon-guanbibaojing icon'
  },
  1: {
    title: 'integration.turn_on_alarm',
    icon: 'iconfont icon-baojing icon'
  }
}

const configStatus = {
  0: {
    title: 'configStatus.wait',
    icon: 'el-icon-set-up'
  },
  1: {
    title: 'configStatus.configuring',
    icon: 'el-icon-connection color-orange'
  },
  2: {
    title: 'configStatus.configured',
    icon: 'el-icon-odometer'
  },
  3: {
    title: 'configStatus.fail',
    icon: 'el-icon-folder-delete'
  }
}

export const gatewayType = {
  1: {
    title: 'gatewayType.gw1',
    icon: 'el-icon-data-line'
  },
  2: {
    title: 'gatewayType.gw1GPS',
    icon: 'el-icon-data-board'
  },
  3: {
    title: 'gatewayType.gw2',
    icon: 'iconfont icon-wangguan2'
  }
}
export const displayscreenType = {
  1: {
    title: 'displayType.dsp1',
    icon: 'iconfont icon-lcd'
  }
}
export const relayType = {
  1: {
    title: 'relayType.relay1',
    icon: 'el-icon-s-operation'
  }
}
// 智能底座类型
export const baseType = {
  1: {
    title: 'baseType.bt_915',
    icon: 'iconfont icon-dizuo color-theme'
  },
  2: {
    title: 'baseType.bt_433',
    icon: 'iconfont icon-dizuo color-gray'
  },
  3: {
    title: 'baseType.bt_g',
    icon: 'iconfont icon-dizuo color-red'
  },
  4: {
    title: 'baseType.bt_4g',
    icon: 'iconfont icon-dizuo color-orange'
  }
}

// 智能底座绑定状态
export const baseBindStatus = {
  0: {
    title: 'business.unbind',
    icon: 'iconfont icon-unlock color-green'
  },
  1: {
    title: 'integration.binding',
    icon: 'iconfont icon-lock'
  }
}

// 智能底座状况
export const baseSituation = {
  0: { title: 'integration.fall_off' },
  1: { title: 'integration.embed' }
}

// 报警开关
export const alarm = {
  0: {
    title: 'alarm.close',
    icon: 'iconfont icon-guanbibaojing'
  },
  1: {
    title: 'alarm.open',
    icon: 'iconfont icon-baojing'
  }
}

export const customerType = {
  0: {
    title: 'public.customer_type_noplatform',
    icon: 'el-icon-user'
  },
  1: {
    title: 'public.customer_type_platform',
    icon: 'el-icon-user-solid'
  }
}
const customerStatus = {
  0: {
    title: 'public.customer_status_cancel',
    icon: 'el-icon-circle-close color-red bolder'
  },
  1: {
    title: 'public.customer_status_active',
    icon: 'el-icon-circle-check color-green bolder'
  }
}

// 探测设备类型
export const equiType = {
  0: {
    title: 'equiType.sensor',
    icon: 'iconfont icon-chuanganqi1'
  },
  1: {
    title: 'equiType.gateway',
    icon: 'iconfont icon-wangguan'
  },
  2: {
    title: 'equiType.display',
    icon: 'iconfont icon-lcd'
  },
  3: {
    title: 'equiType.relay',
    icon: 'el-icon-s-operation'
  },
  4: {
    title: 'equiType.base',
    icon: 'iconfont icon-dianjidizuo'
  }
}

const userType = {
  0: {
    title: 'public.create_user',
    icon: 'el-icon-user'
  },
  1: {
    title: 'public.sync_user',
    icon: 'orange el-icon-user'
  }
}

// 设备是否可跟踪
const trace = {
  0: {
    title: 'traceOff',
    icon: 'el-icon-delete-location'
  },
  1: {
    title: 'traceOn',
    icon: 'el-icon-location-information'
  }
}
// 分析项图标转换
const analItem = {
  ex: {
    title: 'analEx',
    icon: 'el-icon-s-marketing'
  },
  alarm: {
    title: 'analAlarm',
    icon: 'iconfont icon-baojing'
  },
  normalAbnormal: {
    title: 'analNormalAbnormal',
    icon: 'el-icon-pie-chart'
  },
  offerline: {
    title: 'analOffline',
    icon: 'el-icon-s-marketing'
  },
  configure: {
    title: 'analConfigure',
    icon: 'el-icon-crop'
  },
  powerout: {
    title: 'analPowerout',
    icon: 'el-icon-connection'
  }
}
// 文件类型
const fileType = {
  0: {
    title: 'Excel',
    icon: 'iconfont icon-file-excel'
  },
  1: {
    title: 'PDF',
    icon: 'iconfont icon-PDF'
  }
}
// 下载状态
const downLoad = {
  0: {
    title: 'generating',
    icon: 'el-icon-remove'
  },
  1: {
    title: 'generated',
    icon: 'el-icon-success color-green'
  },
  2: {
    title: 'genFail',
    icon: 'el-icon-error color-red'
  }
}

// 报警策略
export const alarmStrategy = {
  1: { title: 'integration.delay_normal_alarm' },
  2: { title: 'integration.delay_ignore_alarm' }
}

// 审批状态
export const approvalStatus = {
  0: {
    title: 'integration.approval_rejected',
    icon: 'el-icon-circle-close color-red bolder'
  },
  1: {
    title: 'integration.approved',
    icon: 'el-icon-circle-check color-green bolder'
  },
  2: {
    title: 'integration.not_approved',
    icon: 'iconfont icon-weixuanzhong color-gray bolder'
  }
}

// 默认温湿度单位
export const defaultUnit = {
  temp: '°C',
  hum: '%',
  '°C': '°C',
  '%': '%',
  'gas': '%LEL',
  'magnetism': '',
  'gs_1': '%LEL',
  'gs_2': '%LEL',
  'gs_3': '%LEL',
  'gs_4': '%LEL',
  'gs_5': '%LEL',
  'gs_6': '%vol',

}
// 每页标签数量
export const gateway02TagSize = {
  1: { title: 1 },
  2: { title: 2 },
  4: { title: 4 },
  6: { title: 6 },
  8: { title: 8 }
}

// 报警策略对应的提示
export const alarmStrategyTip = {
  1: {
    title: 'integration.no_matter_whether_the_data_becomes_normal_within_the_delay_time_c__the_abnormal_alarm_will_still_alarm'
  },
  2: {
    title: 'integration.a_delay_alarm_is_set_in_the_layered_alarm_dot__within_the_delay_time_c__the_data_becomes_normal_again_c__and_the_alarm_trigger_will_ignore_the_alarm_and_will_not_alarm_again'
  }
}
// 工单状态
export const workStatus = {
  '-1': {
    title: 'integration.cancel',
    icon: 'iconfont icon-quxiaofabu'
  },
  0: {
    title: 'integration.acceptance',
    icon: 'iconfont icon-yewushouli'
  },
  1: {
    title: 'integration.handle',
    icon: 'iconfont icon-dingdanchuli'
  },
  2: {
    title: 'resource.confirm',
    icon: 'iconfont icon-gongdanqueren'
  },
  3: {
    title: 'integration.evaluate',
    icon: 'iconfont icon-pingjia'
  }
}
// 工单状态
export const reasonIcon = {
  0: {
    title: 'integration.default',
    icon: 'el-icon-coin'
  },
  1: {
    title: 'integration.custom',
    icon: 'el-icon-set-up'
  }
}

// 操作记录 - 操作成功 or 操作失败
export const operationResult = {
  0: {
    title: 'integration.operation_failed',
    icon: 'el-icon-close color-red'
  },
  1: {
    title: 'integration.operation_successful',
    icon: 'el-icon-check'
  }
}

// 底座策略
export const baseStrategy = {
  1: {
    title: 'integration.use_latest_device_data',
    desc:
      '只要标记了已绑定的智能底座的设备,无论设备脱落,还是其他原因导致实际情况没有绑定,系统统一将最新标记绑定的设备探测的数据填充为有效数据'
  }
}

// 监测点类型转换
export const carrierTypeConvert = function (type) {
  type = String(type)
  return carrierType[type] || unknown
}

// 设备状态类型转换
export const equiStatusConvert = function (status) {
  status = String(status)
  return equiStatus[status] || {}
}

// 异常类型图标转换
/**
 *
 * @param {string} marks 异常编码
 * @returns 根据编码生成的异常类型名与图标 Array
 */
export const abnormalTypeConvert = function (marks) {
  marks = String(marks)
  const mark = marks.split('').reverse()
  const result = []
  for (let i = 0; i < 8; i++) {
    const idx = i + 1
    if (mark[idx] === '1') {
      result.push(abnormal[idx])
    }
  }
  return result
}
// 检测任务状态
export const detectionTask = {
  0: {
    icon: 'el-icon-video-pause',
    title: 'integration.deactivation_status'
  },
  1: {
    icon: 'el-icon-video-play',
    title: 'integration.running_state_'
  }
}
// 异常记录的7种异常
export const abTextInfo = {
  0: {
    title: 'integration.abnormal_sensor_connection',
    icon: 'iconfont icon-yichang'
  },
  1: {
    title: 'integration.abnormal_sensor_temperature',
    icon: 'iconfont icon-yichangliucheng'
  },
  2: {
    title: 'integration.abnormal_sensor_humidity',
    icon: 'iconfont icon-rizhiyichang'
  },
  3: {
    title: 'integration.gateway_connection_exception',
    icon: 'iconfont icon-yichang1'
  },
  4: {
    title: 'integration.gateway_power_failure_exception',
    icon: 'iconfont icon-yichang2'
  },
  5: {
    title: 'integration.abnormal_connection_of_display_screen',
    icon: 'iconfont icon-yichangfenxi'
  },
  6: {
    title: 'integration.abnormal_relay_connection',
    icon: 'iconfont icon-chuliyichang'
  }
}

// 参数类型
export const paramsType = {
  alarm: { title: 'integration.alarm_parameters' },
  net: { title: 'integration.network_parameters' },
  net_2: { title: 'integration.network_parameters_02' },
  app: { title: 'integration.escalation_rules' },
  gps: { title: 'integration.gps_p' },
  range: { title: 'integration.monitoring_interval' }
}

// 设备状态按钮
// title 字段存 i18n key 字符串（而非预翻译值），由各页面模板内调用 $t(deviceStatusButton[sensorWay].title) 实时响应语言切换
export const deviceStatusButton = {
  [ENUM_DEVICE_WAY.BIND]: {
    title: 'integration.device_hint_bound'
  },
  [ENUM_DEVICE_WAY.UNBIND]: {
    title: 'integration.device_hint_unbound'
  },
  [ENUM_DEVICE_WAY.STOP]: {
    title: 'integration.device_hint_inactive'
  },
  [ENUM_DEVICE_WAY.UNCONFIRM]: {
    title: 'integration.device_hint_pending'
  }
}
// 取样策略
export const sampleSrategy = {
  1: {
    title: 'public.Latest_collected_data_sampling',
    desc:  $t('public.Latest_collected_data_sampling_desc')
  },
  2: {
    title: 'public.Maximum_value_data_sampling',
    desc:
     $t('public.Maximum_value_data_sampling_desc')
  },
  3: {
    title: 'public.Minimum_value_data_sampling',
    desc:
    $t('public.Minimum_value_data_sampling_desc')
  },
  4: {
    title: 'public.Avg_value_data_sampling',
    desc:
    $t('public.Avg_value_data_sampling_desc')
  },
  5: {
    title: 'public.Equilibrium_value_data_sampling',
    desc:
    $t('public.Equilibrium_value_data_sampling_desc')
  }
}
// 智能底座策略
export const baseDataStrategy = {
  1: {
    title: 'integration.force_use_latest_bound_device_data',
    desc:
      '只要标记了已绑定的智能底座的设备,无论设备脱落,还是其他原因导致实际情况没有绑定,系统统一将最新标记绑定的设备探测的数据填充为有效数据'
  },
  2: {
    title: 'integration.custom_processing_strategy',
    desc: '当出现脱落等情况时,由用户自己到相关功能页面进行数据处理'
  }
}
// 关联方式
export const relateWay = {
  1: {
    title: 'integration.force_replacement',
    desc: '如设备已关联其他资产，强制替换资产'
  },
  2: {
    title: 'integration.prompt_duplicate',
    desc: '如设备已关联其他资产，应用时，弹出提示框并不能进行保存操作'
  }
}
// 运行停止
export const triggerEvent = {
  0: {
    title: 'integration.stop_it',
    icon: 'iconfont icon-tingzhi color-red'
  },
  1: {
    title: 'text.Activated',
    icon: 'el-icon-video-play color-green'
  }
}

// 报警原因
export const alarmReason = {
  0: { title: 'integration.abnormal_connection' },
  1: { title: 'integration.abnormal_data' },
  2: { title: 'integration.abnormal_power_failure' }
}

// platformType
export const roleType = {
  0: {
    title: 'public.role_type_noplatform',
    icon: 'el-icon-eleme'
  },
  1: {
    title: 'public.role_type_platform',
    icon: 'el-icon-platform-eleme'
  }
}

// 账户类型
export const accountType = {
  [ENUM_ROLE_TYPE.PROXY_MANA]: {
    title: 'integration.agent_management',
    icon: 'el-icon-user-solid account-type-proxy-manager'
  },
  [ENUM_ROLE_TYPE.CUSTOMER_USE]: {
    title: 'integration.customer_use',
    icon: 'el-icon-user-solid account-type-customer-use'
  },
  [ENUM_ROLE_TYPE.CUSTOMER_MANA]: {
    title: 'integration.customer_management',
    icon: 'el-icon-user-solid account-type-customer-manager'
  },
  [ENUM_ROLE_TYPE.PLATFORM_USE]: {
    title: 'integration.platform_usage',
    icon: 'el-icon-user-solid account-type-platform-use'
  },
  [ENUM_ROLE_TYPE.PLATFORM_MANA]: {
    title: 'integration.platform_management',
    icon: 'el-icon-user-solid'
  }
}
// 账户状态
export const accountStatus = {
  0: {
    icon: 'el-icon-warning-outline',
    title: 'integration.cancellation'
  },
  1: {
    icon: 'el-icon-warning',
    title: 'integration.activation'
  }
}

export const exType = {
  0: { cls: 'ex-connection-tag' },
  1: { cls: 'ex-data-tag' },
  2: { cls: 'ex-power-tag' }
}
// 账户默认
export const accountDefault = {
  0: {
    icon: 'el-icon-star-off',
    title: 'public.account_type_nodefault'
  },
  1: {
    icon: 'el-icon-star-on',
    title: 'public.account_type_default'
  }
}

// 监测点模式
export const carrierMode = {
  1: { title: 'integration.normal_mode' },
  2: { title: 'integration.transport_mode'}
}

// zigbee参数状态
export const zigbeeParamsStatus = {
  0: { title: 'integration.no_relevant_parameters' },
  1: { title: 'integration.normal_reporting_data' }
}

// 电源状态
export const powerStatus = {
  0: { title: 'device.normal_power_supply' },
  1: { title: 'device.no_power_supply' }
}
// tcp状态
export const tcpStatus = {
  1: { title: 'integration.tcp_connection_service_is_normal' },
  0: { title: 'integration.tcp_connection_service_exception' }
}
// lte状态
export const lteStatus = {
  0: { title: 'integration.lte_connection_server_is_normal'  },
  1: { title: 'integration.lte_connection_server_exception' }
}
// 飞行模式
export const flightMode = {
  0: { title: 'integration.flight_mode' },
  1: { title: 'integration.not_in_flight_mode' }
}
// 二代Zigbee温度计工作模式
export const secGenZigbeeTempMode = {
  1: { title: 'integration.async_mode' },
  2: { title: 'integration.sync_mode' },
  3: { title: 'integration.fix_mode' }
}

export const fourGSesnorMode = {
  1: { title: 'integration.interval_variation_mode' },
  2: { title: 'integration.sync_mode' },
  3: { title: 'integration.fix_mode' }
}

// 配置步骤
export const configStep = {
  wait: { title: 'integration.initialization_command' },
  'wait-modify': { title: 'integration.modify_configuration' },
  'part-success': { title: 'integration.some_commands_are_configured' },
  success: { title: 'integration.configuration_successful' },
  overtime: { title: 'integration.overtime' },
  sending: { title: 'integration.configuring' },
  failure: { title: 'configStatus.fail' }
}

// 开启关闭
export const openClose = {
  0: { title: 'public.close' },
  1: { title: 'public.open' }
}

// 账户类型转换
export const accountTypeConvert = function (type = 1) {
  return accountType[type] || {}
}
// 账户状态转换
export const accountStatusConvert = function (status = 1) {
  return accountStatus[status] || {}
}
// 账户默认转换
export const accountDefaultConvert = function (type = 1) {
  return accountDefault[type] || {}
}

/**
 *
 * @param {Number} status
 * 根据监测点状态返回对应的图标与title
 */
export const carrierStatusConvert = function (status) {
  status = String(status)
  return carrierStatus[status] || {}
}

/**
 * 是否异常状态图标转换  1异常 0正常
 */
export const isAbnormalConvert = function (abnormal) {
  abnormal = String(abnormal)
  return isAbnormal[abnormal] || {}
}

/**
 * 是否异常状态图标转换  1异常 0正常
 */
export const isMapAbnormalConvert = function (abnormal) {
  abnormal = String(abnormal)
  return isMapAbnormal[abnormal] || {}
}

/**
 * 是否异常状态图标转换  1异常 0正常 2 停止
 */
export const isCarrierAbnormalConvert = function (abnormal) {
  abnormal = String(abnormal)
  return isCarrierAbnormal[abnormal] || {}
}
/**
 * 是否报警状态图标转换  1开启 0关闭
 */
export const isAlarmConvert = function (abnormal) {
  abnormal = String(abnormal)
  return isAlarm[abnormal] || {}
}

/**
 * 配置状态转换
 */
export const configStatusConvert = function (status = 2) {
  status = String(status)
  return configStatus[status] || {}
}

export const gatewayTypeConvert = function (type) {
  type = String(type)
  return gatewayType[type] || {}
}

export const displayscreenTypeConvert = function (type) {
  type = String(type)
  return displayscreenType[type] || {}
}

// 冗余 以防调错接口
export const displayTypeConvert = displayscreenTypeConvert

export const relayTypeConvert = function (type) {
  type = String(type)
  return relayType[type] || relayType[1]
}

export const baseTypeConvert = function (type) {
  type = String(type)
  return baseType[type] || {}
}

export const baseBindStatusConvert = function (status) {
  status = String(status)
  return baseBindStatus[status] || {}
}
export const alarmConvert = function (status) {
  status = String(status)
  return alarm[status] || {}
}
// 设备类型转换
export const equiTypeConvert = function (type) {
  type = String(type)
  return equiType[type] || {}
}

// 设备图标转换  能实现温湿度计  中继1.0等图标的转换 需要提供一个设备类型  和类型id
export const equiIconConvert = function (type, typeId) {
  type = String(type)
  typeId = String(typeId)
  switch (type) {
    case 'sensor':
      return sensorTypeConvert(typeId)
    case 'gateway':
      return gatewayTypeConvert(typeId)
    case 'display':
      return displayTypeConvert(typeId)
    case 'relay':
      return relayTypeConvert(typeId)
    case 'base':
      return baseTypeConvert(typeId)
    case 'gas':
      return gasTypeConvert(typeId)
    case 'magnetism':
      return magnetismTypeConvert(typeId)
    case '0':
      return sensorTypeConvert(typeId)
    case '1':
      return gatewayTypeConvert(typeId)
    case '2':
      return displayTypeConvert(typeId)
    case '3':
      return relayTypeConvert(typeId)
    case '4':
      return baseTypeConvert(typeId)
    case '5':
      return gasTypeConvert(typeId)
    case '6':
      return magnetismTypeConvert(typeId)
    default:
      return {}
  }
}
// 客户类型转换
export const customerTypeConvert = function (type) {
  type = String(type)
  return customerType[type] || {}
}

// 客户状态转换
export const customerStatusConvert = function (status) {
  status = String(status)
  return customerStatus[status] || {}
}

// 用户类型转换
export const userTypeConvert = function (type) {
  if (type === undefined) {
    type = 0
  }

  type = String(type)
  return userType[type] || {}
}

// 是否可追踪转换
export const traceConvert = function (type) {
  type = String(type)
  return trace[type] || {}
}
// 分析项图标转换
export const analItemConvert = function (type) {
  type = String(type)
  return analItem[type] || {}
}
export const fileTypeConvert = function (type = '0') {
  type = String(type)
  return fileType[type] || {}
}
export const downLoadConvert = function (type = '0') {
  type = String(type)
  return downLoad[type] || {}
}
// 工单状态
export const workStatusConvert = function (type) {
  type = String(type)
  return workStatus[type] || {}
}
// 审批状态ICON转换
export const approvalStatusConvert = function (status) {
  if (status === null) {
    status = 2
  }
  return approvalStatus[status] || {}
}
// 操作结果
export const operationResultConvert = function (status) {
  status = String(status)
  return operationResult[status] || {}
}
// 原因
export const reasonConvert = function (status) {
  status = String(status)
  return reasonIcon[status] || {}
}
// 检测任务状态转换
export const detectionTaskConvert = function (status) {
  status = String(status)
  return detectionTask[status] || {}
}
// 异常原因的7种异常
export const abTextInfoConvert = function (status) {
  status = String(status)
  return abTextInfo[status] || {}
}

//切换方式
export const switchType = {
  1: {
    title: 'device.intelligent_switch',
  },
  2: {
    title:  'device.manual_switch',
  },
  3: {
    title:  'device.direct_switch',
  }
}
//切换取消时间
export const switchTime = {
  1: {
    title: 'task.detection_interval_minute',
  },
  2: {
    title: 'task.detection_interval_hour',
  },
  3: {
    title: 'task.detection_interval_day',
  }
}
// 设备切换方式类型转换
export const switchTypeConvert = function (type) {
  type = String(type)
  return switchType[type] || {}
}
// 设备切换结果转换
export const switchResultConvert = function (result) {
  switch (result){
    case 0:
      return $t('device.not_reached')
    case 1:
      return $t('device.eligible')
    case 2:
      return $t('device.user_switch')
    case 3:
      return $t('device.ignore_switch')
    case 4:
      return $t('device.direct_switch')
    case 5:
      return $t('device.user_stop')
    default:
      return ''
  }
}
// 设备切换结果转换
export const switchStatusConvert = function (status) {
  switch (status){
    case 0:
      // 待启动
      return $t('public.to_be_start')
    case 1:
      // 进行中
      return $t('public.doing')
    case 2:
      // 成功
      return $t('public.success')
    case 3:
      // 失败
      return $t('public.fail')
  }
}
// 设备切换取消时间转换
export const switchTimeConvert = function (type) {
  type = String(type)
  return switchTime[type] || {}
}

// 验证任务状态
export const verificationStatus = [
  {
    value: 0,
    label: 'integration.stop_it'
  },
  {
    value: 1,
    label:  'text.Activated'
  }
]

// 时间单位
export const timeUnits = [
  {
    value: 1,
    label: $t('task.detection_interval_minute')
  },
  {
    value: 2,
    label: $t('task.detection_interval_hour')
  },
  {
    value: 3,
    label:$t('task.detection_interval_day')
  },
]

// 无效异常消息
export const invalidMsg = [
  // 确认异常
  {
    value: 'abnormal',
    label: 'integration.confirm_abnormal_msg',
    color: 'gray'
  },
  // 疑似
  {
    value: 'suspecte',
    label: 'integration.suspected_abnormal_msg',
    color: 'orange'

  },
  // 确认正常
  {
    value: 'normal',
    label: 'integration.confirm_normal_msg',
    color: 'green'
  },
]
// 无效异常消息
export const dataType = [
  {
    value: 1,
    label: $t('public.temp'),
  },
  {
    value: 2,
    label: $t('public.hum'),

  },
  {
    value: 3,
    label:$t('integration.confirm_normal_msg'),
  },
  {
    value: 4,
    label:$t('integration.confirm_normal_msg'),
  },
]

export const dateUnits = [
  {
    value: 1,
    label:$t('task.detection_interval_day')
  },
  {
    value: 2,
    label: $t('integration.month')
  },
]

// 无效规则
export const ruleTypes = {
  'tempRule': {
    title: 'integration.temp_data_rule'
  },
  'humRule': {
    title: 'integration.hum_data_rule'
  },
  'offlineRule': {
    title: 'integration.device_offline_rule'
  },
  'powerOffRule': {
    title: 'integration.power_off_rule'
  }
}

// 无效规则转换
export const ruleTypesConvert = function (type) {
  type = String(type)
  return ruleTypes[type] || {}
}

// 根据不同的规则（温度/湿度/设备）返回不同的rule
export const ruleItemType = function (type) {
  switch(type){
    case 'tempRule':
    case 'humRule':
      return {
        1: {
          title: $t('integration.unm_fault_tolerant')
        },
        2: {
          title: $t('integration.time_fault_tolerant')
        },
        3: {
          title: $t('integration.continuity_anomaly')
        },
        // 4: {
        //   title: $t('integration.abnormal_frequency')
        // },
      }
    case 'offlineRule':
      return {
        5: {
          title: $t('integration.reconnect_duration')
        },
        // 4: {
        //   title: $t('integration.abnormal_frequency')
        // },
      }
    case 'powerOffRule':
      return {
        6: {
          title: $t('integration.power_duration')
        },
        3: {
          title: $t('integration.continuity_anomaly')
        },
        // 4: {
        //   title: $t('integration.abnormal_frequency')
        // },
      }
  }
}

// 设备类型转换
export const deviceTypeConvert = function (type) {
  switch (type) {
    case 'sensor':
      return $t('equiType.sensor')
    case 'gateway':
      return $t('equiType.gateway')
    case 'display':
      return $t('equiType.display')
    case 'relay':
      return $t('equiType.relay')
    case 'gas':
      return $t('equiType.gas')
    case 'magnetism':
      return $t('equiType.magnetism')
    default:
      return ''
  }
}
// 设备状态转换
export const deviceStatusConvert = function (type) {
  switch (type) {
    case 'totalCount':
      return $t('public.total_num')
    case 'onLine':
      return $t('public.online')
    case 'offLine':
      return $t('public.offline')
    case 'stopCount':
      return $t('public.stop')
    case 'unknownCount':
      return $t('public.unconfirm')
    default:
      return ''
  }
}
// 验证任务异常状态转换
export const verifyExConvert = function (type) {
  switch (type) {
    case 1:
      return $t('public.ex_data')
    case 2:
      return $t('public.ex_offline')
    default:
      return ''
  }
}
// 气体设备的类型
export const gasType = {
  1: {
    title: 'gasType.0x00',
    icon: 'iconfont icon-yanwu'
  },
  2: {
    title: 'gasType.0x01',
    icon: 'iconfont icon-jiawan'
  },
  3: {
    title: 'gasType.0x04',
    icon: 'iconfont icon-yiyanghuatan'
  },
  4: {
    title: 'gasType.0x0A',
    icon: 'iconfont icon-bingwanbaobiao'
  },
  5: {
    title: 'gasType.0x32',
    icon: 'iconfont icon-standard'
  },
  6: {
    title: 'gasType.gs_6',
    icon: 'iconfont icon-eryanghuatan'
  }
}

export const gasTypeConvert = function (type) {
  type = String(type)
  return gasType[type] || {}
}

// 门磁设备的类型
export const magnetismType = {
  1: {
    title: 'magnetismType.m1',
    icon: 'iconfont icon-menci'
  },
}

export const magnetismTypeConvert = function (type) {
  type = String(type)
  return magnetismType[type] || {}
}

// 门磁探测值类型：1-开启；0-关闭
export const magnetismValTypeConvert = function (type) {
  switch(type){
    case 1:
      return $t('public.open')
    case 0:
      return $t('public.close')
    default:
      return ''
  }
}
// 事务类型
export const thingTypeConvert = {
  // 申请设备
  '0': $t('public.apply_equipment'),
  // 设备维护
  '1': $t('public.equipment_maintenance'),
  '2': $t('route.other'),
}

export const deviceTypeConvertFun = function (type_code) {
  type_code = String(type_code)
  return deviceTypeListConvert[type_code]
}

// 总的设备类型，细分
export const deviceTypeListConvert = {
  'zbp_1': $t('sensorType.ZigBeeTemp'),
  'zbp_2': $t('sensorType.ZigBeeTempHum'),
  'lora_1': $t('sensorType.LoraTemp'),
  'lora_2': $t('sensorType.LoraTempHum'),
  'zeta_1': $t('sensorType.ZetaTemp'),
  'zeta_2': $t('sensorType.ZetaTempHum'),
  'zbp_3': $t('sensorType.ZigBee2Temp'),
  'zbp_4': $t('sensorType.ZigBee2TempHum'),
  '4g_1': $t('sensorType.FourGTemp'),
  '4g_2': $t('sensorType.FourGTempHum'),
  '4g_3': $t('sensorType.FourGTempGps'),
  '4g_4': $t('sensorType.FourGTempHumGps'),
  'gt_1': $t('gatewayType.gw1'),
  'gt_2': $t('gatewayType.gw1GPS'),
  'gt_3': $t('gatewayType.gw2'),
  'dt_1': $t('displayType.dsp1'),
  'rt_1': $t('relayType.relay1'),
  'pt_1': $t('baseType.pt_1'),
  'pt_2': $t('baseType.pt_2'),
  'gs_1': $t('gasType.0x00'),
  'gs_2': $t('gasType.0x01'),
  'gs_3': $t('gasType.0x04'),
  'gs_4': $t('gasType.0x0A'),
  'gs_5': $t('gasType.0x32'),
  'gs_6': $t('gasType.gs_6'),
  'mg_1': $t('magnetismType.m1'),
}

// 监测区间单位
export const unitCodeConvert = function (unit) {
  switch(unit){
    case '℃':
    case 1:
      return 'temp'
    case '%RH':
    case 2:
      return 'hum'
    case '%vol':
    case 11:
      return 'coz'
    case '%LEL':
    case 9:
      return 'gas'
    default:
      return 'temp'
  }
}
// 监测区间单位
export const unitIdConvert = function (unitCode) {
  switch(unitCode){
    case 'temp':
      return 1
    case 'hum':
      return 2
    case 'gas':
      return 9
    case 'coz':
      return 11
    default:
      return 1
  }
}

export const shiquArrayConvert = function (code) {
   return $t('device.'+ code)

}
export default {
  carrierTypeConvert,
  equiStatusConvert,
  abnormalTypeConvert,
  carrierStatusConvert,
  isAbnormalConvert,
  isMapAbnormalConvert,
  sensorTypeConvert,
  configStatusConvert,
  gatewayTypeConvert,
  relayTypeConvert,
  equiTypeConvert,
  customerTypeConvert,
  customerStatusConvert,
  userTypeConvert,
  traceConvert,
  fileTypeConvert,
  analItemConvert,
  isCarrierAbnormalConvert,
  isAlarmConvert,
  downLoadConvert,
  displayscreenTypeConvert,
  equiIconConvert,
  displayTypeConvert,
  workStatusConvert,
  approvalStatusConvert,
  operationResultConvert,
  reasonConvert,
  detectionTaskConvert,
  abTextInfoConvert,
  baseTypeConvert,
  baseBindStatusConvert,
  gasTypeConvert,
  magnetismTypeConvert,
  deviceTypeConvertFun
}

// 导出所有图标 主要用于图标说明
export const icon = {
  sensorStatus,
  carrierStatus,
  trace,
  isCarrierAbnormal,
  abnormal,
  carrierType,
  sensorType,
  configStatus,
  equiStatus,
  gatewayType,
  relayType,
  displayscreenType,
  isAlarm,
  approvalStatus,
  workStatus,
  reasonIcon,
  fileType,
  downLoad,
  customerType,
  customerStatus,
  detectionTask,
  abTextInfo,
  baseType,
  baseBindStatus,
  triggerEvent,
  accountType,
  accountStatus,
  accountDefault,
  roleType,
  gasType,
  magnetismType
}
